/**
 * Check my sequences: readiness + recommendations per Framework sequence.
 * The check runs only when the writer asks (it spends on their key); the last
 * one is kept and read back free. Recommendations are advice; ignore any.
 */
import { api } from './client';

const unwrap = (res) => (res?.data?.data ?? res?.data ?? res);

/** Run a new check (paid). */
export async function runSequenceCheck(storyId) {
  return unwrap(await api.post(`/stories/${storyId}/plot-focus/recommendations`, {}));
}

/** Check one sequence before its Generate (paid, one sequence). Advice only. */
export async function checkOneSequence(storyId, sequenceName) {
  return unwrap(await api.post(`/stories/${storyId}/plot-focus/recommendations/sequence`, {
    sequence_name: sequenceName,
  }));
}

/** The last check, as of now (free). { check: null } until one has run. */
export async function getSequenceCheck(storyId) {
  return unwrap(await api.get(`/stories/${storyId}/plot-focus/recommendations`));
}

export async function ignoreRecommendation(storyId, sequenceName, talkFingerprint) {
  return unwrap(await api.post(`/stories/${storyId}/plot-focus/recommendations/dismiss`, {
    sequence_name: sequenceName,
    talk_fingerprint: talkFingerprint,
  }));
}

export async function showRecommendationAgain(storyId, sequenceName) {
  return unwrap(await api.post(`/stories/${storyId}/plot-focus/recommendations/restore`, {
    sequence_name: sequenceName,
  }));
}
